import * as React from 'react';

export const ShowUploadsPanelContext = React.createContext<{
  showUploadsPanel: boolean;
  setShowUploadsPanel: React.Dispatch<React.SetStateAction<boolean>>;
} | null>(null);
